import {NAME} from './constants'

export const CREATE_DEVICE_ACCESS = NAME + '_CREATE_DEVICE_ACCESS';
